// O JWT só carrega o e-mail, então o rodapé da sidebar precisa saber tirar
// iniciais de "lucas.goncalves@coopersystem.com.br" quando o nome falta.
export function initialsFrom(user) {
  const source = user?.name?.trim() || user?.email?.split("@")[0]?.replace(/[._-]+/g, " ") || "";
  const words = source.split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";

  const first = words[0][0];
  const last = words.length > 1 ? words[words.length - 1][0] : "";
  return `${first}${last}`.toUpperCase();
}
